import { ApolloLink } from "apollo-link";
import gql from "graphql-tag";

export default ({ ssr }) =>
  !ssr &&
  new ApolloLink((operation, forward) => {
    const cache = operation.getContext().cache;
    const query = gql`
      {
        me {
          id
        }
      }
    `;

    let disableCache;
    try {
      const data = cache.readQuery({ query });
      const isLoggedIn = Boolean(data?.me?.id);
      disableCache = isLoggedIn;
    } catch (error) {
      disableCache = true;
    }
    if (disableCache) {
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          "cache-control": "max-age=0, no-store",
        },
      }));
    }
    return forward(operation);
  });
